module.exports = __webpack_public_path__ + "img/schedule-finished.cb1ad81a.png";